import * as React from 'react';

const FindInCircle = ({
  backgroundColor = 'inherit',
  iconColor = 'rgba(14, 19, 35, 0.35)',
}) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="30" height="30" rx="15" fill={backgroundColor} />
    <path
      d="M21.7 20.3L19.6 18.2C20.5 17 21 15.6 21 14C21 10.1 17.9 7 14 7C10.1 7 7 10.1 7 14C7 17.9 10.1 21 14 21C15.6 21 17 20.5 18.2 19.6L20.3 21.7C20.5 21.9 20.8 22 21 22C21.2 22 21.5 21.9 21.7 21.7C22.1 21.3 22.1 20.7 21.7 20.3ZM9 14C9 11.2 11.2 9 14 9C16.8 9 19 11.2 19 14C19 16.8 16.8 19 14 19C11.2 19 9 16.8 9 14Z"
      fill={iconColor}
    />
  </svg>
);
export default FindInCircle;
